import React, { ReactNode } from "react";
import { useTheme } from "../../Hooks";
import useWindowDimensions from "../../Hooks/UseWindowDiemensions";
import { FmBox } from "../FmBox";

import useStyles from "./FmWarningBox.style";

interface FmWarningBoxProps {
  icon: any;
  description: string | ReactNode;
}

const FmWarningBox = ({ icon, description }: FmWarningBoxProps) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const theme = useTheme();

  const isMobile = width < theme.breakpoints.values.desktop;

  const containerClass = isMobile ? classes.mobile_container : classes.container;

  return (
    <FmBox variant="orange">
      <div className={containerClass}>
        <div>
          <img src={icon} alt="icon" />
        </div>
        <div>{description}</div>
      </div>
    </FmBox>
  );
};

export default FmWarningBox;
